import { makeStyles } from "@material-ui/core/styles";
import { fontClasses } from "../../../fontStyles";

const useMobileStyles = makeStyles((theme) => ({
  schedulerWrapper: {
    background: theme.palette.primary.background,
    height: "100%",
  },
  isReadOnlyMode: {
    padding: 0,
    pointerEvents: "none",
    background: "none",
    height: "auto",
    "& $wrapper": {
      background: "none",
      boxShadow: "none",
      padding: 0,
      "& $pageTitle": {
        display: "none",
      },
      "& $dayLabel": {
        width: 16,
        height: 16,
      },
    },
    "& $note, & $editWrapper": {
      display: "none",
    },
    "& $timeline": {
      background: "none",
      height: 20,
    },
    "& $timelineBox": {
      borderRadius: 2,
    },
  },
  handleWrapper: {
    top: "40%",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    width: 12,
    height: 12,
    cursor: "ew-resize",
    pointerEvents: "auto",
    touchAction: "none",
    "& svg": {
      width: 12,
      height: 12,
      filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.5))",
    },
  },
  popupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #BABEC3",
    backgroundColor: theme.palette.primary.cardBackground,
    padding: 14,
    flexShrink: 0,
    boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.06)",
    color: theme.palette.primary.mainText,
  },
  popupTitle: {
    ...fontClasses.title1,
    fontSize: "16px",
    fontWeight: "600",
    color: theme.palette.primary.mainText,
  },
  closeButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 8,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& path": {
      fill: theme.palette.primary.mainHeading,
    },
  },
  wrapper: {
    padding: 16,
    background: theme.palette.primary.cardBackground,
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.10)",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  dayLabel: {
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    fontSize: 10,
    cursor: "pointer",
    fontWeight: 400,
  },
  timeline: {
    position: "relative",
    height: 30,
    flex: 1,
    background: theme.palette.primary.cardBackground,
    borderRadius: 10,
  },
  hourLine: {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: 1,
    borderLeft: `1px solid ${theme.palette.primary.dashedBorderColor}`,
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 10,
  },
  footerTimeline: {
    position: "relative",
    flex: 1,
    height: 30,
    fontSize: 10,
    color: theme.palette.tertiary.commonText,
  },
  timelineBox: {
    position: "absolute",
    top: 5,
    borderRadius: 4,
    pointerEvents: "none",
  },
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  tooltip: {
    position: "absolute",
    top: -28,
    background: "#000",
    color: "#fff",
    fontSize: 11,
    padding: "4px 8px",
    borderRadius: 4,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    zIndex: 100000,
  },
  xAxisLabel: {
    color: theme.palette.tertiary.commonText,
    textAlign: "right",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
  },
  editBlocksRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: 10,
    margin: "8px 0",
    height: 70,
    touchAction: "none",
    justifyContent: "center",
  },
  disableEditBlock: {
    pointerEvents: "none",
    opacity: 0.4,
  },
  deleteEditRow: {
    marginTop: 48,
  },
  highlightBlock: {
    border: `1px solid ${theme.palette.primary.mainText}`,
    boxSizing: "border-box",
    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
  },
  pageTitle: {
    marginBottom: 16,
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 500,
    color: theme.palette.primary.mainText,
  },
  pageTitleEdit: {
    marginBottom: 0,
  },
  note: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.tertiary.commonText,
    marginTop: 10,
    height: 16,
  },
  editBlockCard: {
    padding: "8px 2px",
    width: 52,
    flexShrink: 0,
    borderRadius: 2,
    background: theme.palette.primary.iqAirSettingsCardColor,
    textAlign: "center",
    border: `1px solid ${theme.palette.primary.iqAirSettingsCardColor}`,
    cursor: "pointer",
    touchAction: "none",
    userSelect: "none",
    transition: "all 0.2s ease",
    position: "relative",
  },
  dragging: {
    opacity: 0.6,
    transform: "scale(1.1)",
    zIndex: 10,
  },
  activeCard: {
    borderColor: "#01B5DE",
  },
  reorderMode: {
    cursor: "grab",
  },
  reorderActiveCard: {
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#00B5D8",
    background: theme.palette.primary.cardBackground,
    transform: "translateY(-6px) scale(1.05)",
    boxShadow: "0 6px 14px rgba(0, 0, 0, 0.15)",
    zIndex: 5,
  },
  deleteBadge: {
    position: "absolute",
    top: -8,
    right: -8,
    width: 20,
    height: 20,
    background: "#00b4de",
    color: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    cursor: "pointer",
    zIndex: 10,
  },
  deleteBadgeSelected: {
    background: "#e53935",
  },
  editBlockColor: {
    width: 24,
    height: 12,
    borderRadius: 2,
    margin: "0 auto 6px",
    border: "1px solid #fff",
  },
  editBlockName: {
    fontSize: 9,
    fontWeight: 400,
    color: theme.palette.primary.mainText,
  },
  editBlockTemp: {
    fontSize: 8,
    fontWeight: 400,
    color: theme.palette.primary.mainText,
    opacity: 0.6,
    marginTop: 2,
  },
  noDaySelected: {
    opacity: 0.4,
    pointerEvents: "none",
  },
  editTimeBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
  },
  iconsBox: {
    display: "flex",
    gap: 12,
  },
  editTimeIcons: {
    borderRadius: 8,
    border: "1px solid #00b4de",
    background: "transparent",
    display: "flex",
    cursor: "pointer",
    width: 24,
    height: 24,
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    aspectRatio: "1/1",
  },
  disableIcon: {
    pointerEvents: "none",
    cursor: "not-allowed",
    borderColor: "#ccc",
  },
  selectedModeIcon: {
    background: "#01B5DE",
    borderColor: "#01B5DE",
    "&:nth-child(2n)": {
      "& svg path": {
        fill: "#fff",
        stroke: "unset",
      },
    },
    "& svg path": {
      stroke: "#fff",
    },
  },
  dropdownWrapper: {
    position: "absolute",
    right: 82,
    width: "auto",
    background: theme.palette.primary.cardBackground,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
    zIndex: 100,
    top: "100%",
    pointerEvents: "auto",
    overflowX: "hidden",
    overflowY: "auto",
    overscrollBehavior: "contain",
    maxHeight: 180,
    minWidth: 120,
    color: theme.palette.primary.mainText,
  },
  timePicker: {
    right: "unset",
    width: "100%",
    height: 162,
    overflowX: "hidden",
    overflowY: "auto",
    bottom: 25,
    "& $dropdownItem": {
      fontSize: 12,
    },
  },
  selectedTimePicker: {
    background: theme.palette.type === 'dark' ? '#00bcd4' : '#e6f7fb',
    color: theme.palette.type === 'dark' ? '#fff' : '#000',
  },
  dropdownItem: {
    display: "flex",
    alignItems: "center",
    fontSize: 12,
    color: theme.palette.primary.mainText,
    cursor: "pointer",
    flexDirection: "column",
    transition: "background 0.2s",
    "&:hover": {
      background: theme.palette.primary.iqAirSettingsCardColor,
    },
    "&:active": {
      background: theme.palette.primary.iqAirSettingsCardColor,
    },
  },
  lastItem: {
    borderBottom: "none",
  },
  selectedItem: {
    background: "#e6f7fb",
  },
  dropdownDot: {
    width: 12,
    height: 12,
    borderRadius: 3,
  },
  editTimeTimers: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
    marginBottom: 12,
  },
  inDeleteMode: {
    display: "none",
  },
  inDeleteModeVisibility: {
    visibility: "hidden",
  },
  timersField: {
    borderBottom: `1px solid ${theme.palette.primary.dashedBorderColor}`,
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 500,
    color: theme.palette.primary.mainText,
    position: "relative",
    "& $dropdownItem": {
      "& span": {
        marginLeft: 12,
        padding: 12,
        paddingLeft: 20,
      },
    },
    "& span": {
      width: "100%",
      display: "flex",
    },
  },
  timersFieldLabel: {
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: 400,
    color: theme.palette.tertiary.commonText,
    marginBottom: 6,
  },
  dropdownColor: {
    display: "flex",
    alignSelf: "baseline",
    paddingLeft: 12,
    paddingTop: 12,
    paddingBottom: 12,
    gap: 4,
  },
  editWrapper: {
  },
  dropdownDivider: {
    bottom: 0,
    left: 22,
    right: 22,
    height: 1,
    background: theme.palette.primary.dashedBorderColor,
    width: "calc(100% - 24px)",
    margin: "0 24px",
  },
}));

export { useMobileStyles };
